function SkillTags({ skills }) {
  return (
    <div className="experience-skills">
      {skills.map((skill) => (
        <div key={skill}>{skill}</div>
      ))}
    </div>
  );
}

export default SkillTags;
